export default __webpack_public_path__ + "static/media/yellow-pie.d7673585.svg";